import {
  AccessPeriodRadioGroup,
  AccessPermissionsRadioGroup,
} from 'app/components/access-sharing';
import React from 'react';
import {
  IAccessSharingPeriodType,
  IAccessSharingPermissionType,
} from 'types/IAccessSharingUser';
import './AccessConfiguration.less';

interface Props {
  initialPermission?: IAccessSharingPermissionType;
  period: IAccessSharingPeriodType;
  startDate: Date | null;
  endDate: Date | null;
  onChangePermission: (value: IAccessSharingPermissionType) => void;
  onChangePeriod: (value: IAccessSharingPeriodType) => void;
  onChangeStartDate: (value: Date | null) => void;
  onChangeEndDate: (value: Date | null) => void;
}

export default function AccessConfiguration({
  initialPermission,
  period,
  startDate,
  endDate,
  onChangePermission,
  onChangePeriod,
  onChangeStartDate,
  onChangeEndDate,
}: Props) {
  return (
    <div className="access-configuration">
      <AccessPermissionsRadioGroup
        className="access-configuration__radio_group"
        initialValue={initialPermission}
        onChange={onChangePermission}
      />

      <AccessPeriodRadioGroup
        className="access-configuration__radio_group"
        value={period}
        startDate={startDate}
        endDate={endDate}
        onChange={onChangePeriod}
        onChangeStartDate={onChangeStartDate}
        onChangeEndDate={onChangeEndDate}
      />
    </div>
  );
}
